import actionTypes from '../constants/action-types';

const registerInterruption = (interruption) => ({
  type: actionTypes.REGISTER_INTERRUPTION,
  payload: {
    interruption,
  },
});

export default registerInterruption;
